import { JsonObject, JsonProperty } from "json2typescript";
import { BaseResponse } from "./base-response";

@JsonObject("BooleanResp")
export class BooleanResp extends BaseResponse {
	@JsonProperty("data", Boolean, true)
	data: boolean = false;
}